import { createAction } from 'redux-actions';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { reduxKey } from './constants';
import { getRecipientForComment, getRecipientForDeviation } from '../utils';
export var pushAwardBadgeModal = function (recipient) {
    return pushModal(ModalType.AWARD_BADGE, {
        params: { recipient: recipient },
        wrapInModal: false,
    });
};
export var beginDeviationAwardBadgeFlow = function (deviation) {
    return pushAwardBadgeModal(getRecipientForDeviation(deviation));
};
export var beginCommentAwardBadgeFlow = function (comment) {
    return pushAwardBadgeModal(getRecipientForComment(comment));
};
export var awardBadge = createAction("".concat(reduxKey, "/AWARD"), function (badgeType, recipient) { return ({
    badgeType: badgeType,
    recipient: recipient,
}); });
export var awardingBadge = createAction("".concat(reduxKey, "/AWARDING"), function () { return ({}); });
export var awardBadgeSuccess = createAction("".concat(reduxKey, "/AWARD.SUCCESS"), function (badge, recipient, newBalance, allBadges) { return ({
    badge: badge,
    recipient: recipient,
    newBalance: newBalance,
    allBadges: allBadges,
}); });
export var awardBadgeFail = createAction("".concat(reduxKey, "/AWARD.FAIL"), function (badgeType, recipient, errorMsg) { return ({
    badgeType: badgeType,
    recipient: recipient,
    errorMsg: errorMsg,
}); });
export var fetchAvailableBadges = createAction("".concat(reduxKey, "/FETCH_AVAILABLE_BADGES"), function (userId) { return ({ userId: userId }); });
export var fetchAvailableBadgesSuccess = createAction("".concat(reduxKey, "/FETCH_AVAILABLE_BADGES.SUCCESS"), function (userId, results) { return ({ userId: userId, results: results }); });
export var fetchBadgeGiverStreamNext = createAction("".concat(reduxKey, "/BADGE_GIVER_STREAM.FETCH_NEXT"), function (streamId) { return ({ streamId: streamId }); });
//# sourceMappingURL=actionCreators.js.map